import React from 'react';

const InputRadioGroup = ({inputName, title, values, handleChange, selectedOption}) => {
  return (
    <div className="input-radio-group">
      <p className="input-radio-group-title">{title}</p>
      <hr />
      {values.map((val) => (
        <label key={val.email} className="radio">
          <input
            type="radio"
            name={inputName}
            value={val.email}
            className="input-form-radio"
            checked={selectedOption === val.email}
            onChange={(e) => handleChange(e.target.value)}
          />
          {val.email}
        </label>
      ))}
    </div>
  );
};

export default InputRadioGroup;
